import React, { useEffect, useState } from "react";
import "../Home/Home.css";
import HeaderSection from "../../Components/HeaderSection";
import Main from "../Main/Main";
import { Sidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Link, useLocation } from "react-router-dom";
import MainContainer from "../../Components/MainContainer/MainContainer";
import SideBar from "../../Components/SideBarComponent/SideBar";
import VerificationScreen from "../Verification/VerificationScreen";
import Dashboard from "../Dashboard/Dashboard";
import SignatureCrop from "../SignatureVerificationScreen/SignatureCrop";
import MenuContainer from "../../Components/MenuContainer/MenuContainer";
import AdminScreen from "../AdminScreens/AdminScreen";
import FaceMatching from "../FaceMatching/FaceMatching";
import ClientDetails from "../AdminScreens/ClietnDetailsPage/ClientDetails";
import HitDashboard from "../../pixlhitScreens/HitDashboard";
import HitOverview from "../../pixlhitScreens/Hit/HitOverview";
import ApiHits from "../Apihits/ApiHits";
import DocumentComparison from "../DocumentComparison/DocumentComparison";
import ServiceLogs from "../ServiceLogs/ServiceLogs";
import MainWrapper from "../Main/MainWrapper";
import HeadlessAppHitLogs from "../HeadlessAppHitLogs/HeadlessAppHitLogs";
import { DIRECTAIMENUS } from "../../globalData/constant";

function Home({
  selectedMenu = "",
  isdoubleSide = false,
  documentSideKeys = [],
  sideBarComponent = [],
  section = "",
  fields = [],
  headerName,
  discription = '',
  discriptionHead = ""
}) {
  const { pathname } = useLocation()
  const [isToggled, setisToggled] = useState(true);
  const [toggleStatus, settoggleStatus] = useState(false);
  const [header, setHeader] = useState()

  const item = (data) => {
    if (toggleStatus) {
      setisToggled(!data);
    } else {
      settoggleStatus(false);
      setisToggled(data);
    }
  };
  const toggleStat = () => {
    setisToggled(false);
    settoggleStatus(true);
  };

  useEffect(() => {
    //console.log(sideBarComponent);
  }, []);
  // //""

  // //console.log(section);

  useEffect(() => {
    setHeader(renderHeader)
  }, [pathname])


  const renderHeader = () => {
    switch (pathname) {
      case "/admin/clientlist":
        return ("Account Listing")
        break;
      case "/admin/clientdetails":
        return ("Account Details")
        break;
      case "/admin/hit-services":
        return ("Service List")
        break;

    }
  }

  const renderSectionComponent = () => {
    // //""
    //console.log(section)
    switch (section) {

      case "Admin Dashboard":
        return (
          <MenuContainer headerName={header} setisToggled={setisToggled} isToggled={isToggled} >
            <AdminScreen />
          </MenuContainer>
        );

        break;

      case "DashBoard":
        return <Dashboard selectedMenu={selectedMenu} ListedMenu={sideBarComponent} />

        break;

      case "Document Verification":
        // alert('ale')
        return <VerificationScreen headerName={headerName} setisToggled={setisToggled} isToggled={isToggled} selectedMenu={selectedMenu} fields={fields} discription={discription} discriptionHead={discriptionHead} />

        break;

      case "Document Reader":
        if(DIRECTAIMENUS?.includes(selectedMenu)){
          return (
            <MainWrapper
              setisToggled={setisToggled} isToggled={isToggled}
              selectedMenu={selectedMenu}
              headerName={headerName}
              isdoubleSide={isdoubleSide}
              documentSideKeys={documentSideKeys}
            />
          );

        }else{
          return (
            <Main
              setisToggled={setisToggled} isToggled={isToggled}
              selectedMenu={selectedMenu}
              headerName={headerName}
              isdoubleSide={isdoubleSide}
              documentSideKeys={documentSideKeys}
            />
          );
        }
        break;

      case "OVD Classification":
        return (
          <Main
            setisToggled={setisToggled} isToggled={isToggled}
            selectedMenu={selectedMenu}
            isdoubleSide={isdoubleSide}
            headerName={headerName}
            documentSideKeys={documentSideKeys}
          />
        );
        break;
      case "Signature Croping":
        return (
          <SignatureCrop />
        );
        break;
      case "Face Matching":
        return (
          <FaceMatching />
        );
        break;
      case "Signature Varification":
        return (
          <MenuContainer headerName={headerName} setisToggled={setisToggled} isToggled={isToggled}>
          </MenuContainer>
        );
        break;
      case "Hit Dashboard":
        // alert('jelo')
        return (
          // <ClientDetails />
          <MenuContainer headerName={headerName} setisToggled={setisToggled} isToggled={isToggled}>
            <HitDashboard />
          </MenuContainer>
        );
        break;
      case "API Hit":
        // alert('jelo')
        return (
          // <ClientDetails />
          <MenuContainer headerName={headerName} setisToggled={setisToggled} isToggled={isToggled}>
            <HitOverview />
          </MenuContainer>
        );
        break;

      case "API Logs":
        return (
          <MenuContainer headerName={header} setisToggled={setisToggled} isToggled={isToggled} >
            <ApiHits />
            {/* <ServiceLogs/> */}
          </MenuContainer>)
      case "API Logs2":
        return (
          <MenuContainer headerName={header} setisToggled={setisToggled} isToggled={isToggled} >
            {/* <ApiHits /> */}
            <ServiceLogs/>
          </MenuContainer>)
      case "API Logs3":
        return (
          <MenuContainer headerName={header} setisToggled={setisToggled} isToggled={isToggled} >
            <HeadlessAppHitLogs/>
          </MenuContainer>)
      case "Document Compare":
      return (
        <MenuContainer selectedMenu={selectedMenu} headerName={header} setisToggled={setisToggled} isToggled={isToggled}>
          <DocumentComparison selectedMenu={selectedMenu}/>
        </MenuContainer>
      )


      default:
        return (
          <Main
            setisToggled={setisToggled} isToggled={isToggled}
            selectedMenu={selectedMenu}
            isdoubleSide={isdoubleSide}
            headerName={headerName}
            documentSideKeys={documentSideKeys}
          />
        );
        break;
    }
  };

  return (
    <>
      <MainContainer >

        <div className="sidebar_wrapper side_bar">
          <SideBar
            isToggled={isToggled}
            toggleStat={toggleStat}
            sideBarComponent={sideBarComponent}
          />

          {/* <Main selectedMenu={selectedMenu} isdoubleSide={isdoubleSide}  documentSideKeys={documentSideKeys}/> */}

          {/* <Main selectedMenu={"Pan Reader"} /> */}

          {renderSectionComponent()}
        </div>
      </MainContainer>
    </>
  );
}

export default Home;
